module.exports = __webpack_public_path__ + "img/borderline.a4616f7f.svg";